//selectors
export const BASE_SURVEY_SELECTOR = 'page-survey';
export const HISTORY_SELECTOR = 'survey-history';
export const BACK_BUTTON_SELECTOR = 'back-button';
export const FORWARD_BUTTON_SELECTOR = 'forward-button';
export const ANSWERS_SELECTOR = 'survey-answers';
export const QUESTION_SELECTOR = 'survey-question';
export const QUESTION_SELECTOR_SUBTITLE = 'survey-question-subtitle';
export const SUBTITLE_SELECTOR = 'survey-subtitle-name';
export const ZIPCODE_ERROR_LABEL_SELECTOR = 'zipcode-error-label';
export const ZIPCODE_CHECK_BUTTON_SELECTOR = 'zipcode-check-button';
export const ZIPCODE_CHECK_INPUT_SELECTOR = 'zipcode-check-input';
export const ZIPCODE_EMAIL_INPUT_SELECTOR = 'zipcode-email-input';
export const ZIPCODE_EMAIL_BUTTON_SELECTOR = 'zipcode-email-button';
export const ZIPCODE_PRIVACY_INPUT_SELECTOR = 'zipcode-privacy-input';
export const ZIPCODE_LEAD_BOX_SELECTOR = 'zipcode-lead-box'
export const ZIPCODE_ERROR_NO_PRIVACY_LABEL_SELECTOR = "zipcode-no-privacy-error"
export const ZIP_CODE_PRIVACY_HTML_SELECTOR = "zipcode-privacy-html"
export const NAVIGATION_PANEL_SELECTOR = 'survey-navigation-panel';
export const ZIP_CODE_FOUND = 'Cap trovato'
export const ZIP_CODE_NOT_FOUND = 'CAP non trovato'
export const SURVEY_PROGRESSBAR = 'survey-progressbar'
export const SURVEY_PROGRESSBAR_FILL = 'survey-progress-bar-fill';
export const SURVEY_BODY_SELECTOR = "survey-body";
//separatore
export const HASH_SEPARATOR = '/';
//selettori per i listener delle azioni (click)
export const ANSWER_BUTTON_ID_PREFIX = 'answer-card';
//altro
